import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from './Icon';

const TABS = [
    { id: 'home',     label: 'Главная',  icon: 'home',     iconFill: 'home-fill',     path: '/' },
    { id: 'comments', label: 'Комменты', icon: 'comment',  iconFill: 'comment-fill',  path: '/comments' },
    { id: 'search',   label: 'Поиск',    icon: 'search',   iconFill: 'search',        path: '/search' },
    { id: 'saved',    label: 'Сохранено',icon: 'bookmark', iconFill: 'bookmark-fill', path: '/profile?tab=collections' },
    { id: 'profile',  label: 'Профиль',  icon: 'user',     iconFill: 'user-fill',     path: '/profile' },
];

export default function BottomTabBar() {
    const navigate  = useNavigate();
    const location  = useLocation();
    const { pathname, search } = location;
    const tab = new URLSearchParams(search).get('tab');

    const activeId = (() => {
        if (pathname === '/') return 'home';
        if (pathname === '/search') return 'search';
        if (pathname.startsWith('/comments')) return 'comments';
        if (pathname === '/profile' && tab === 'collections') return 'saved';
        if (pathname === '/profile') return 'profile';
        return null;
    })();

    return (
        <div className="hb-tab-bar" style={{
            position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 50,
            paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            background: 'rgba(10,10,11,0.94)',
            backdropFilter: 'blur(20px) saturate(1.6)',
            WebkitBackdropFilter: 'blur(20px) saturate(1.6)',
            borderTop: '1px solid #131316',
        }}>
            <div style={{
                display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)',
                padding: '6px 4px 8px',
            }}>
                {TABS.map(t => {
                    const on = activeId === t.id;
                    return (
                        <a
                            key={t.id}
                            href={t.path}
                            onClick={(e) => { e.preventDefault(); navigate(t.path); }}
                            style={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
                                background: 'transparent', border: 0, padding: '6px 2px',
                                color: on ? '#e60073' : '#71717A', cursor: 'pointer', textDecoration: 'none',
                            }}
                        >
                            <Icon name={on ? t.iconFill : t.icon} size={22} color={on ? '#e60073' : '#71717A'} stroke={1.7} />
                            <span style={{
                                fontSize: 10, fontWeight: on ? 600 : 400,
                                fontFamily: "'Manrope', sans-serif",
                            }}>{t.label}</span>
                        </a>
                    );
                })}
            </div>
        </div>
    );
}
